import { render } from "./AreaCheckbox.vue?vue&type=template&id=7c22a8d1&scoped=true&ts=true"
import script from "./AreaCheckbox.ts?vue&type=script&lang=ts&external"
export * from "./AreaCheckbox.ts?vue&type=script&lang=ts&external"

import "../Checkbox.scss?vue&type=style&index=0&id=7c22a8d1&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c22a8d1"]])

export default __exports__